import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const removeUserDevice = async ({
	userId,
	deviceId
}: {
	userId: string;
	deviceId: number;
}) => {
	const response = await cmsClient.delete(
		`/homepage/admin/store/user/${userId}/devices/${deviceId}/`
	);
	return response.data;
};

const useRemoveUserDevice = (userId: string) => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(<CustomToast type="Success" message="Device removed" />, {
			hideProgressBar: true
		});
	};

	const onSettled = () => {
		queryClient.invalidateQueries(["user-devices", userId]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	return useMutation(removeUserDevice, { onError, onSuccess, onSettled });
};

export default useRemoveUserDevice;
